<template>
  <div :class="{ [$style.basket]: true, [$style['basket--disabled']]: disabled }">
    <svg
      :class="$style.triangle"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      viewBox="0 0 1 1"
    >
      <path :class="$style.path" d="M0,0 l1,0 l-1,1 z" />
    </svg>
    <div v-show="!appShopModus && hasMyRole" :class="$style['basket-info']">
      <div :class="[$style.row, $style.icon]">
        <IconSelect icon="basket" height="30" width="30" :icon-props="{ 'stroke-width': 1 }" />
        <v-progress-circular
          v-show="pending"
          :class="$style.spinner"
          size="15"
          width="2"
          :indeterminate="pending"
          color="white"
        />
        <span :class="$style.amount">{{ disabled || basketInitial ? '-' : amount }}</span>
      </div>
      <span :class="[$style.row, $style.price]">{{
        disabled || basketInitial ? '-' : priceFormatted
      }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'

import { REQUEST_STATE } from '@/js/plugins/store/modules/aimeos/constants'
import aimeosGetters from '@/js/plugins/store/modules/aimeos/getter-types'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'
import { DP_ROLE } from '@/js/helper/dp-usermanagement-constants'
import PermissionMixin from '@/js/mixins/permission-mixin.js'

import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

export default {
  name: 'MiniBasket',
  components: {
    IconSelect,
  },
  mixins: [PermissionMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      myRole: DP_ROLE.SHOP_ORDER_R.p,
    }
  },
  computed: {
    ...mapGetters(STOREMODULES.AIMEOS, {
      amount: aimeosGetters.BASKET_COUNT,
      price: aimeosGetters.BASKET_PRICE,
      currency: aimeosGetters.BASKET_CURRENCYID,
      pending: `BASKET_${REQUEST_STATE.STATE_PENDING}`,
      basketInitial: `BASKET_${REQUEST_STATE.STATE_INITIAL}`,
    }),
    ...mapGetters(STOREMODULES.APP, {
      appShopModus: APP_GETTER.SHOPMODUS,
    }),
    priceFormatted() {
      return this.price ? this.$n(this.price, { key: 'currency', currency: this.currency }) : '-'
    },
  },
}
</script>

<style lang="scss" module>
.basket {
  position: relative;

  display: inline-flex;
  align-items: center;

  height: 5rem;

  color: var(--white);
  line-height: 1.5rem;

  background-color: var(--black);
  cursor: pointer;

  user-select: none;
}

.basket--disabled {
  cursor: default;
}

.basket-info {
  min-width: 3.75rem;
  margin: 0 0.625rem;

  .amount {
    color: var(--primary);
    font-weight: var(--font-weight-bold);
  }

  .price {
    justify-content: flex-end;
    margin-top: 0.5rem;

    font-size: var(--font-sm);
  }
}

.triangle {
  width: 36px;
  height: 100%;
}

.row {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-between;
}

.path {
  fill: var(--navigation-background-color);
}

.icon {
  position: relative;
}

.spinner {
  position: absolute;
  top: 4px;
  left: 8px;

  background: var(--black);
}
</style>
